import { render } from "./ElementaryProgramDataTable.vue?vue&type=template&id=78924a25"
import script from "./ElementaryProgramDataTable.vue?vue&type=script&lang=js"
export * from "./ElementaryProgramDataTable.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__